export enum ContactBtnPosition {
    CONTACT_INFO_TOP = 'contactInfoTop',
    CONTACT_INFO_BOTTOM = 'contactInfoBottom',
    STICKY_BAR = 'stickyBar',
}
